import { render, staticRenderFns } from "./StorageUpdate.vue?vue&type=template&id=1a958205&scoped=true&"
import script from "./StorageUpdate.vue?vue&type=script&lang=js&"
export * from "./StorageUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a958205",
  null
  
)

export default component.exports